
const set_token= (token) => ({ type: "ADD_TOKEN", token: token })
const set_fio = (fio) => ({ type: "ADD_FIO", fio: fio })
const set_phone = (phone) => ({ type: "ADD_PHONE", phone: phone })
const set_inn = (inn) => ({ type: "ADD_INN", inn: inn })
const set_last_name = (last_name) => ({ type: "ADD_LAST_NAME", last_name: last_name })
const set_first_name = (first_name) => ({ type: "ADD_FIRST_NAME", first_name: first_name })
const set_second_name = (second_name) => ({ type: "ADD_SECOND_NAME", second_name: second_name })
const set_email = (email) => ({ type: "ADD_EMAIL", email: email })
const set_referer = (referer) => ({ type: "ADD_REFERER", referer: referer })
const set_doc_number = (doc_number) => ({ type: "ADD_DOC_NUMBER", doc_number: doc_number })
const set_city = (city) => ({ type: "ADD_DOC_CITY", city: city })
const set_birth_date= (birth_date) => ({ type: "ADD_BIRTH_DATE", birth_date: birth_date })
const set_doc_date= (doc_date) => ({ type: "ADD_DOC_DATE", doc_date: doc_date })
const set_amount = (amount) => ({ type: "ADD_AMOUNT", amount: amount })
const set_days = (days) => ({ type: "ADD_DAYS", days: days })
const set_code = (code) => ({ type: "ADD_CODE", code: code })
const set_code_final = (final_code_url) => ({ type: "ADD_FINAL_CODE_URL", final_code_url: final_code_url })


export {
    set_code_final,
    set_token,
    set_fio,
    set_phone,
    set_inn,
    set_last_name,
    set_first_name,
    set_second_name,
    set_email,
    set_referer,
    set_doc_number,
    set_city,
    set_birth_date,
    set_doc_date,
    set_amount,
    set_days,
    set_code
}



// WEBPACK FOOTER //
// src/actions/userDataActions.js